import { render, staticRenderFns } from "./PageMassMessageStat.vue?vue&type=template&id=6f474d5e&"
import script from "./PageMassMessageStat.vue?vue&type=script&lang=ts&"
export * from "./PageMassMessageStat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports